import {Fragment, useState} from 'react';

import {MegaMenu} from 'primereact/megamenu';
import {UseInvoiceReportService as Service} from './UseInvoiceReportService';

import {Filter} from '../filter';
import {FormatDisplay} from '../../../shared/format';

export default function TinhHinhSuDung() {

  const [displayFilter, setDisplayFilter] = useState(null);
  const [filter, setFilter] = useState({});

  const [items, setItems] = useState([]);

  const downloadExcel = () => {
    Service.downloadExcel(filter).then(data => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `bao-cao-tinh-hinh-su-dung-hoa-don.xlsx`;
      link.click();
    });
  }

  const search = (params) => {
    setFilter(params);
    setDisplayFilter(false);

    Service.getList(params).then(data => {
      setItems(data);
    });
  }

  const actions = [
    {label: 'Lọc dữ liệu', icon: 'pi pi-fw pi-filter', className: 'iam-toolbar iam-toolbar-secondary', command: () => setDisplayFilter(true)},
    {label: 'Kết xuất excel', icon: 'pi pi-fw pi-file-excel', className: 'iam-toolbar iam-toolbar-secondary', command: downloadExcel}
  ];

  return (
    <Fragment>
      <MegaMenu model={actions}/>
      <Filter header="Báo cáo tình hình sử dụng hóa đơn" display={displayFilter} setDisplay={setDisplayFilter} search={search}
              hiddenFields={['buyerTaxCode', 'invoiceStatus', 'sendTaxStatus']}/>

      <div className="p-datatable p-component p-datatable-responsive-scroll p-datatable-gridlines p-datatable-sm">
        <div className="p-datatable-wrapper">
          <table className="p-datatable-table">
            <colgroup>
              <col style={{width: '50px'}}/>
              <col style={{width: '150px'}}/>
              <col style={{minWidth: '100px'}}/>
              <col style={{minWidth: '100px'}}/>
              <col style={{minWidth: '100px'}}/>
              <col style={{minWidth: '100px'}}/>
              <col style={{minWidth: '100px'}}/>
              <col style={{minWidth: '100px'}}/>
              <col style={{minWidth: '150px'}}/>
              <col style={{minWidth: '150px'}}/>
              <col style={{minWidth: '150px'}}/>
            </colgroup>
            <thead className="p-datatable-thead">
            <tr role="row">
              <th rowSpan={2} role="columnheader" className="justify-content-center">
                <div className="p-column-header-content"><span className="p-column-title">#</span></div>
              </th>
              <th rowSpan={2} role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Ký hiệu</span></div>
              </th>
              <th colSpan={6} role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Trạng thái hóa đơn gửi thành công</span></div>
              </th>
              <th rowSpan={2} role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Tổng số hóa đơn gửi thành công</span></div>
              </th>
              <th rowSpan={2} role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Tổng số hóa đơn gửi không thành công</span></div>
              </th>
              <th rowSpan={2} role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Tổng số hóa đơn sử dụng</span></div>
              </th>
            </tr>
            <tr role="row">
              <th role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Gốc</span></div>
              </th>
              <th role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Thay thế</span></div>
              </th>
              <th role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Điều chỉnh</span></div>
              </th>
              <th role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Bị thay thế</span></div>
              </th>
              <th role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Bị điều chỉnh</span></div>
              </th>
              <th role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Hủy</span></div>
              </th>
            </tr>
            </thead>
            <tbody className="p-datatable-tbody">
            {items?.map((item, index) => <tr key={index}>
              <td className="text-center">{(index + 1)}</td>
              <td className="text-center">{item.symbol}</td>
              <td className="text-center">{FormatDisplay.number(item.original)}</td>
              <td className="text-center">{FormatDisplay.number(item.substitute)}</td>
              <td className="text-center">{FormatDisplay.number(item.adjust)}</td>
              <td className="text-center">{FormatDisplay.number(item.substituted)}</td>
              <td className="text-center">{FormatDisplay.number(item.adjusted)}</td>
              <td className="text-center">{FormatDisplay.number(item.cancel)}</td>
              <td className="text-center">{FormatDisplay.number(item.success)}</td>
              <td className="text-center">{FormatDisplay.number(item.error)}</td>
              <td className="text-center">{FormatDisplay.number(item.totalUse)}</td>
            </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </Fragment>
  );
}